import React from 'react'

import Link from '@Pure/Link'

import _ from 'lodash'

export const form =
{
	model: 'UserFunction'.toLowerCase(),
	name: 'UserFunction'.toLowerCase(),

	form_title: 'Fonction d\'utilisateur',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer cette fonction',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette fonction&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['userfunction[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					La nouvelle fonction <strong> { model.label } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/fonctions/' + model.id }>
						Voir la fonction
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'UserFunction'.toLowerCase(),
	title: 'Liste des fonctions d\'utilisateur',
	link: '/configuration/fonctions',
	creation_link: '/configuration/nouvelle-fonction',
	creation_label: 'Nouvelle fonction',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/fonctions/',
	searched_prop: 'label'
};

let config = _.cloneDeep(form);

_.merge(config, list);

export default config